const language = {
	spanish: {
		button_1: "PROTEJA SU FLOTA",
		button_2: "CONTACTAR A VENTAS",
	},
	english: {
		button_1: "PROTECT YOUR FLEET",
		button_2: "CONTACT SALES",
	},
};

export default language